import { useState, useEffect, useCallback } from "react";
import { sendRequest } from "../requests/useRequest";
import { useSignalRClient } from "../signalR/useSignalRClient";
import { ConfigServer } from "../../data/config";
import { useSweetAlert } from "../sweetAlerts/useSweetAlert";
export const useClientNotifications = () => {

    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(false);
    // const [previousCount, setPreviousCount] = useState(0);
    const [refreshing, setRefreshing] = useState(false);
    const [newNotifications, setNewNotifications] = useState([]);
    const [previousNotifications, setPreviousNotifications] = useState([]);
    // Toast Alert
    const [showToast, setShowToast] = useState(false);
    const [toastType, setToastType] = useState("info");
    const [toastTitle, setToastTitle] = useState("");
    const [toastMessage, setToastMessage] = useState("");
    const [loadingDownloadPdf, setLoadingDownloadPdf] = useState(null);
    const [createSweet] = useSweetAlert();

    //#region TOAST
    const showToastAlert = (
        type = "info",
        title = "",
        message = ""
    ) => {

        setToastType(type);
        setToastTitle(title);
        setToastMessage(message);
        setShowToast(true);

    };

    const closeToastAlert = () => {

        setShowToast(false);
        setToastTitle("");
        setToastMessage("");

    };
    //#endregion


    

    const getNotifications = useCallback(async (showLoading = true) => {
        try {

            if (showLoading) {
                setLoading(true);
            } else {
                setRefreshing(true);
            }

            const requestOptions = { method: "GET"};

            const response = await sendRequest( requestOptions, "ClientNotification/List");

            const data = response.data ?? [];
            setNotifications(data);
            return data;

        } finally {

            setLoading(false);
            setRefreshing(false);

        }

    }, []);

    const handleSignalRNotification = useCallback(async (message) => {
        if (message !== "changes") return;
        const data = await getNotifications();
        const news = [];
        data.forEach(item => {
            const previous = previousNotifications.find(
                x => x.id_work_order === item.id_work_order
            );

            if (!previous) {
                news.push(item.id_work_order);
                return;
            }

            if (
                !item.is_complete &&
                (item.exams?.length ?? 0) > (previous.exams?.length ?? 0)
            ) {
                news.push(item.id_work_order);
            }
        });

        if (news.length > 0) {
            setNewNotifications(prev => [
                ...new Set([...prev, ...news])
            ]);

            const notification = data.find(x =>
                news.includes(x.id_work_order)
            );

            if (notification) {
                showToastAlert(
                    "success",
                    notification.is_complete
                        ? "Resultados completos"
                        : "Resultados parciales",
                    notification.is_complete
                        ? `Los resultados completos de <strong>${notification.patient_name}</strong> <strong>(${notification.nim})</strong> ya están disponibles.`
                        : `<strong>${notification.patient_name}</strong> <strong>(${notification.nim})</strong> tiene resultados parciales disponibles.`
                );
            }
        }
        setPreviousNotifications(data);
    }, [getNotifications, previousNotifications]);


    useSignalRClient({
        funcionRespuesta: handleSignalRNotification
    });


    //   useEffect(() => {
    //     getNotifications().then(data => {
    //         setPreviousCount(data.length);
    //     });
    // }, [getNotifications]);

   
    useEffect(() => {
        getNotifications().then(data => {
            setPreviousNotifications(data);
        });
    }, [getNotifications]);

    const markAsRead = async (id_work_order) => {

        setNotifications(prev =>
            prev.filter(x => x.id_work_order !== id_work_order)
        );

        try {

            const requestOptions = {
                method: "POST"
            };

            await sendRequest(
                requestOptions,
                `ClientNotification/MarkAsReadByWorkOrder/${id_work_order}`
            );

        } catch (err) {

            console.error(err);
            getNotifications();

        }

    };

    const unreadCount = notifications?.length ?? 0;

    const clearNewNotifications = () => {
        setNewNotifications([]);
    };
    

    const printWorkOrder = async (nim) => {
            console.log("ENTRÓ A PRINT", nim);

        setLoadingDownloadPdf(nim);

        try {
            const payload = {
                nim,
                password: "",
                type: "NP",
                is_microsite: true
            };

            const token = localStorage.getItem("token");

            const response = await fetch(
                `${ConfigServer.serverUrl}/api/PrintResult/DownloadSheetResults`,
                {
                    method: "POST",
                    body: JSON.stringify(payload),
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            if (!response.ok) {
                createSweet("warning", "warning", "No se ha podido descargar el PDF");
                return;
            }

            const blob = await response.blob();

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = "hoja_resultados.pdf";

            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);
            console.log("Antes de refrescar");
            const data = await getNotifications(false);
            console.log("Después de refrescar", data);
            createSweet("success", "success", "Descarga completa");

        } catch (error) {
            console.error(error);
            createSweet("error", "Error", "Ocurrió un error al descargar el PDF");
        } finally {
            setLoadingDownloadPdf(null);
        }
    };


   
    return {

        notifications,
        loading,
        refreshNotifications: getNotifications,
        markAsRead,
        unreadCount,

        //? Toast ALERT
        showToast,
        toastType,
        toastTitle,
        toastMessage,
        closeToastAlert, 

        //? REFRESH
        refreshing,

        clearNewNotifications,newNotifications, printWorkOrder, loadingDownloadPdf

    };
};